
import { useLoaderData } from '@tanstack/react-router'

const Page = () => {
    const { branchesOverview } = useLoaderData({ from: '/company/_layout/dashboard/' })
    
    return (
        <div className='flex h-full w-full items-center justify-center'>
            <div className='w-2/3'>
                <div className='flex flex-col w-full'>
                    <h1 className='text-3xl xl:text-5xl mb-4'>Branches Overview</h1>
                    <div className="bg-white p-6 rounded-lg border shadow-sm">
                        <h2 className="text-xl font-semibold mb-4">Company Branches Dashboard</h2>
                        <p className="text-gray-600 mb-6">
                            Monitor and manage all your company branches from this centralized dashboard.
                        </p>
                        
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                            <div className="bg-blue-50 p-4 rounded">
                                <h3 className="font-semibold text-blue-900">Total Branches</h3>
                                <p className="text-2xl font-bold text-blue-600">{branchesOverview?.branches?.length || 0}</p>
                            </div>
                            <div className="bg-green-50 p-4 rounded">
                                <h3 className="font-semibold text-green-900">Active Branches</h3>
                                <p className="text-2xl font-bold text-green-600">
                                    {branchesOverview?.branches?.filter((branch: any) => branch.isActive)?.length || 0}
                                </p>
                            </div>
                            <div className="bg-orange-50 p-4 rounded">
                                <h3 className="font-semibold text-orange-900">Inactive Branches</h3>
                                <p className="text-2xl font-bold text-orange-600">
                                    {branchesOverview?.branches?.filter((branch: any) => !branch.isActive)?.length || 0}
                                </p>
                            </div>
                        </div>

                        {branchesOverview?.branches && branchesOverview.branches.length > 0 && (
                            <div>
                                <h3 className="text-lg font-semibold mb-4">Branch List</h3>
                                <div className="grid gap-4">
                                    {branchesOverview.branches.map((branch: any, index: number) => (
                                        <div key={branch.branchCode || index} className="border rounded-lg p-4 hover:bg-gray-50">
                                            <div className="flex justify-between items-start">
                                                <div>
                                                    <h4 className="font-semibold">
                                                        {branch.branchSize === 'SMALL' 
                                                            ? (branch.pharmacyName || 'Unnamed Pharmacy')
                                                            : (branch.name || 'Unnamed Branch')
                                                        }
                                                    </h4>
                                                    <p className="text-sm text-gray-600">Code: {branch.branchCode}</p>
                                                    {branch.address && (
                                                        <p className="text-sm text-gray-500 mt-1">{branch.address}</p>
                                                    )}
                                                </div>
                                                <span className={`px-2 py-1 rounded text-xs font-medium ${
                                                    branch.isActive 
                                                        ? 'bg-green-100 text-green-800' 
                                                        : 'bg-red-100 text-red-800'
                                                }`}>
                                                    {branch.isActive ? 'Active' : 'Inactive'}
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        
                        {(!branchesOverview?.branches || branchesOverview.branches.length === 0) && (
                            <div className="text-center py-8">
                                <p className="text-gray-500">No branches found for this company.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Page